/**
 * Created by lu on 2018/4/16.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    view: {
        'class': 'order-nav clearfix',
        tag:'ul',
        $html: [{
            'class':'nav-item-left',
            tag: 'li',
            $text: nb.bind('goods')
        }, {
            'class':'nav-item',
            tag: 'li',
            $text: nb.bind('spec')
        }, {
            'class':'nav-item',
            tag: 'li',
            $text: nb.bind('price')
        }, {
            'class':'nav-item',
            tag: 'li',
            $text: nb.bind('num')
        }, {
            'class':'nav-item',
            tag: 'li',
            $text: nb.bind('count')
        }, {
            'class':'nav-item',
            tag: 'li',
            $text: nb.bind('state')
        }, {
            'class':'nav-item',
            tag: 'li',
            $text: nb.bind('operation')
        }]
    }

});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/view/OrderNav.js
// module id = 676
// module chunks = 3